import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import ReactPlayer from "react-player";

function YoutubeVideoPreviewModal({
  openPreviewVideo,
  handleClosePreviewVideo,
  videoUrl,
  customModalStyle,
}) {
  return (
    <Modal
      open={openPreviewVideo}
      onClose={handleClosePreviewVideo}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "65vw",
          height: "85vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          ...customModalStyle,
        }}
      >
        <IconButton
          onClick={handleClosePreviewVideo}
          aria-label="Close video preview"
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 2,
            color: "#FFFFFF",
            backgroundColor: "rgba(0, 0, 0, 0.55)",
            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.75)" },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <ReactPlayer
          url={videoUrl}
          height={"100%"}
          width={"100%"}
          style={{ width: "100%", height: "100%" }}
        />
      </Box>
    </Modal>
  );
}

export default YoutubeVideoPreviewModal;
